import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "optimove",
  "use": "optimove-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"optimove\"><path d=\"M37.357 45.62H10.334L2 19.879 23.895 4 45.79 19.879 37.357 45.62zm-21.944-7.002H32.23l5.178-15.978-13.61-9.862-13.611 9.862 5.227 15.978z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/optimove.svg
// module id = Nmnk
// module chunks = 38 43